import CaptureNameProof from './CaptureNameProof';

export default CaptureNameProof;
